import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass';
import Select from 'react-select';
import { ErrorMessage } from 'formik';
import { TextFieldWrap, Label, ErrorMessageWrap } from '../text/styled';
import { FaInfoCircle } from "react-icons/fa";

export const customStyles = (disabled) => {
  return {
    option: (base, { isSelected, isFocused }) => ({
      ...base,
      padding: 20,
      borderRadius: '31px',
      backgroundColor: isSelected ? '#9B59B6' :
        isFocused ? 'rgba(155, 89, 182, 0.20)' : 'white',
    }),
    menu: (base) => ({
      ...base,
      paddingTop: '0px !important',
      borderRadius: '31px',
    }),
    control: (base, { isFocused }) => ({
      display: 'flex',
      paddingTop: '0px !important',
      border: isFocused ? '1px solid #D1D1D1' : '1px solid #e6e6e6',
      borderRadius: '31px',
      background: disabled ? '#F0F0F2' : 'white',
      cursor: disabled && 'not-allowed',
      boxShadow: 'none',
      height: '44px',
      opacity: disabled ? 0.7 : 1,
    }),
    valueContainer: base => ({
      ...base,
      opacity: disabled ? 0.7 : 1,
      padding: '12px 16px',
    }),
    singleValue: base => ({
      ...base,
      color: '#666',
    }),
  }
};

export const SelectNonFormikField = ({
  options,
  onChange,
  onBlur,
  label,
  name,
  value,
  placeholder,
  subText,
  disabled,
  menuPlacement = "bottom"
}) => <TextFieldWrap sx={{ cursor: disabled && 'not-allowed' }}>
    {label && <Label>{label}</Label>}
    <Select
      isDisabled={disabled}
      className="react-select-container"
      options={options}
      name={name}
      value={options ? options.find(option => option.value === value) : ''}
      onChange={onChange}
      menuPlacement={menuPlacement}
      onBlur={onBlur}
      styles={customStyles(disabled)}
      placeholder={placeholder}
      isSearchable={false}
    />
    {subText && <Flex mt="4px">
      <Text as={FaInfoCircle} color="#B0B0B0" size={14} minWidth={14} />
      <Text
        ml={1}
        sx={{
          color: '#B0B0B0',
          fontFeatureSettings: "'liga' off, 'calt' off",
          fontFamily: 'Poppins',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '16px',
        }}
      >{subText}</Text>
    </Flex>}
  </TextFieldWrap>

const SelectField = ({
  options,
  field,
  form,
  label,
  showError,
  placeholder,
}) => (
  <TextFieldWrap>
    {label && <Label {...field}>{label}</Label>}
    <Select
      className="react-select-container"
      options={options}
      name={field.name}
      value={options ? options.find(option => option.value === field.value) : ''}
      onChange={(option: Option) => form.setFieldValue(field.name, option.value)}
      onBlur={field.onBlur}
      styles={customStyles}
      placeholder={placeholder}
    />
    {showError && <ErrorMessage name={field.name} component={ErrorMessageWrap} />}
  </TextFieldWrap>
);

SelectField.propTypes = {
  field: PropTypes.shape({
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape).isRequired,
  form: PropTypes.shape({
  }).isRequired,
  placeholder: PropTypes.string,
};

SelectField.defaultProps = {
  placeholder: 'Select...',
};

export default SelectField;
